export const Bio = {
  name: "Chanel Morgan",
  roles: [
    "Software Engineer",
    "Web Developer",
    "Java Developer",
    "Programmer",
  ],
  description:
    "I am a driven and adaptable software engineer with a passion for building impactful, user-focused applications. With experience in agile development, automation, and full-stack web solutions, I thrive in fast-paced environments that demand creativity and problem-solving. My projects—from AI-powered games to business websites—reflect my commitment to delivering high-quality, efficient, and innovative solutions.",
  github: "https://github.com/Chanelmorgan",
  resume:
    "https://drive.google.com/file/d/16xYYRy0aRZhI6fVsWnnD-zGqT6M-rWGN/view?usp=sharing",
  linkedin: "www.linkedin.com/in/chanelmorgan",
 
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Tailwind",
        image:
          "/tailwind.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "C/C++",
        image: "/C.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
    
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "/git.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Vercel",
        image:
          "/vercel.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "/postman.webp",
      },
      {
        name: "GitLab",
        image:
          "/gitlab.webp",
      },
      {
        name: "Figma",
        image:
          "/figma.webp",
      },
      {
        name: "Jira & Confluence",
        image:
          "/jira.png",
      },
      {
        name: "IntelliJ",
        image:"/intellij.png",
      },
      {
        name: "Eclipse",
        image:
          "/eclipse.png",
      },
      {
        name: "SVN",
        image:"/svn.png",
      },
      {
        name: "OpenCV",
        image:"/opencv.png",
      },
      {
        name: "Bash",
        image:"/bash.png",
      },
      {
        name: "Jupyter Notebook",
        image:"/jupyter.png",
      },
      {
        name: "PyCharm",
        image:"/pycharm.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/cgi-logo.png",
    role: "Technology Graduate",
    company: "CGI Space, Defense and Intelligence",
    date: "August 2025 - Present",
    desc: "Working in an scrum team, developing software using Java, and streamlining the process with automation.",
    skills: [
      "Docker",
      "Java",
      "SVN",
      "Agile",
      "Scrum",
      "Git Lab",
      "Swing",
      "MongoDB",
      "SQL",
      "Jira",
    ],
    
  },
  {
    id: 0,
    img: "/airbus-logo.png",
    role: "Software Developer Intern",
    company: "Airbus Defense and Space",
    date: "July 2023 - August 2024",
    desc: "Developed and optimised Java-based applications within an agile scrum team, automating critical workflows to reduce manual processing time by 40%. Enhanced system efficiency, contributed to multiple cross-functional projects, and collaborated closely with engineers to deliver high-quality, scalable solutions.",
    skills: [
      "Docker",
      "Java",
      "SVN",
      "Agile",
      "Scrum",
      "Git Lab",
      "Swing",
      "MongoDB",
      "SQL",
      "Jira",
    ],
    
  },
  {
    id: 0,
    img: "/mcd.webp",
    role: "Crew Member",
    company: "McDonald's",
    date: "July 2019 - August 2025",
    desc: "Worked as a team in a fast paced and high pressure environment, while maintaining high customer satisfaction and order accuracy.",
    skills: [
      "Communication",
      "Leadership",
      "Team work",
      "Problem solving",
      "Conflict resolution",
      "Stress management",
      "Adaptability",
      "Flexibility",
      "Financial responsibility",
      "Work ethic",
    ],
  
  },
  {
    id: 1,
    img: "/uea.webp",
    role: "Teaching Assistant",
    company: "University of East Anglia",
    date: "Sep 2024 - Jan 2025",
    desc: "Assisted students on topics such as agile, waterfall, use cases, requirements, ethics and security.",
    skills: [
      "Leadership",
      "Time Management",
      "Mentoring",
      "Patiences",
    ],
  },
  
];

export const education = [
  {
    id: 0,
    img: "/uea.webp",
    school: "University of East Anglia, Norwich",
    date: "Sep 2021 - Jun 2025",
    grade: "First Class",
    desc: "Graduated with First Class Honours in Computer Science, including a year-long industry placement at Airbus Defence and Space. Completed advanced coursework in algorithms, databases, operating systems, and networks, and developed a final-year project implementing real-time face detection using Python and OpenCV.",
    degree: "Bachelor of Computing Science (Hons) with a year in industry",
  },
  {
    id: 1,
    img: "/en.png",
    school: "East Norfolk Sixth Form College, Great Yarmouth",
    date: "Sep 2019 - Jun 2021",
    grade: "Mathematics: A, Biology: A, Chemistry: B",
    desc: "Achieved strong A-level results in Mathematics, Biology, and Chemistry, further developing my analytical and problem-solving skills, as well as my passion for STEM subjects",
    degree: "A levels",
  },
  {
    id: 2,
    img: "/lg.jpeg",
    school: "Lynn Grove Academy, Great Yarmouth",
    date: "Sep 2014 - Jul 2019",
    grade: "Mathematics: 8, Science: 9-9, English language: 7, English literature: 7, Business studies: 8, Geography: 8, Photography: 9",
    desc: " Completed GCSEs with a focus on mathematics and science, achieving high grades across a range of subjects, and building a solid academic foundation for further studies.",
    degree: "GCSE's",
  },
];

export const projects = [
  {
    id: 8,
    title: "Ellie Morgan Hair Website",
    date: "Sep 2024",
    description:
      "A web application designed for a local hair dressing business. It provides a user-friendly interface for users, a simple and modern web interface that allows users to see information about the services quickly.",
    image:
      "/ellie.png",
    tags: [
      "Python",
      "Flask",
      "HTML",
      "CSS",
      "Postman",
      "Node Js",
    ],
    category: "web app",
    github: "https://github.com/Chanelmorgan/flask-ellie-hair",
    webapp: "https://www.elliemorganhair.co.uk",
  },
  {
    id: 0,
    title: "Harmony Steps Dance Website",
    date: "Sep 2024",
    description:
      "Designed and developed a responsive website for a local dance company, integrating Google APIs to enhance location and scheduling features. Built with React, Node.js, and Bootstrap, the platform delivers a seamless experience across all devices and improved event inquiries by 30% within the first month.",
    image:
      "/steps.png",
    tags: ["React Js", "Node Js", "Express Js", "HTML", "CSS", "JavaScript", "Bootstrap", "Postman"],
    category: "web app",
    github: "https://github.com/Chanelmorgan/HarmonyStepsWebsite",
    webapp: "https://harmonystepsdance.co.uk/",
   
  },
  {
    id: 1,
    title: "Live Face Detection System",
    date: "April 2024",
    description:
      "Designed and developed a program that uses the computer web camera a reference image to recognize faces.",
    image:
      "/face.png",
    tags: [
      "Python",
      "OpenCV",
    ],
    category: "python app",
    github: "https://github.com/Chanelmorgan/liveFaceDetectionSystem",
    webapp: "https://github.com/Chanelmorgan/liveFaceDetectionSystem",
  },
  {
    id: 2,
    title: "Point and Click Adventure Game",
    date: "Apr 2024",
    description:
      "A point and click Adventure game built only with Java",
    image:
      "/click.png",
    tags: ["Java", "Swing"],
    category: "java app",
    github: "https://github.com/Chanelmorgan/PointandClickAdventureGame",
    webapp: "https://github.com/Chanelmorgan/PointandClickAdventureGame",
  },
  {
    id: 3,
    title: "2D Game",
    date: "Apr 2024",
    description:
      "A 2D game created only using Java.",
    image:
      "/2d.png",
    tags: ["Java", "Swing"],
    category: "java app",
    github: "https://github.com/Chanelmorgan/2DJavaGame",
    webapp: "https://github.com/Chanelmorgan/2DJavaGame",
  },
  {
    id: 4,
    title: "Black jack with  GUI",
    date: "Mar 2024",
    description:
      "App that allows the users to play balckjack against computer with a visual interface",
    image:
      "/black_jack.png",
      tags: ["Java", "Swing"],
    category: "java app",
    github: "https://github.com/Chanelmorgan/BlackjackWithGUI",
    webapp: "https://github.com/Chanelmorgan/BlackjackWithGUI",
  },
  {
    id: 5,
    title: "Ordering Application",
    date: "Feb 2024",
    description:
      "Java Swing application with GUI to present an odering system.",
    image:
      "/coffee.png",
      tags: ["Java", "Swing"],
    category: "java app",
    github: "https://github.com/Chanelmorgan/BasicCoffeeShop",
    webapp: "https://github.com/Chanelmorgan/BasicCoffeeShop",
  },
  {
    id: 6,
    title: "Flappy Bird AI",
    date: "Jan 2024",
    description:
      "Flappy Bird game that uses Neuroevolution of Augmenting Topologies (NEAT), an evolutionary algorithm that trains an AI to play a game through multiple iterations.",
    image:
      "/flappy.png",
    tags: ["Python", "Machine Learning"],
    category: "python app",
    github: "https://github.com/Chanelmorgan/FlappyBird/tree/AI_flappyBird",
    webapp: "https://github.com/Chanelmorgan/FlappyBird/tree/AI_flappyBird",
  },
  {
    id: 7,
    title: "Planet Simulator",
    date: "Jan 2024",
    description:
      "Python project that uses pygame and real orbital physics to simulate the orbits of a few of the planets in our solar system.",
    image:
      "/planet.png",
      tags: ["Python", "Pygame"],
    category: "python app",
    github: "https://github.com/Chanelmorgan/PlanetSimulation",
    webapp: "https://github.com/Chanelmorgan/PlanetSimulation",
  },
 
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
